// extracted by mini-css-extract-plugin
export default {"loading":"modalUploadTemplate_loading__aK4X2","dots":"modalUploadTemplate_dots__UcuR4"};